import { useField, FieldHookConfig } from 'formik';
import {styled} from '@mui/material';

interface ComponentProps {
	width?: string;
	label?: string;
	options?: HTMLSelectElement;
	placeholder?: string;
	disabled?: boolean
	onChange?: (value: string) => void
}



const Select = (props: ComponentProps & FieldHookConfig<string>) => {
	const [field, meta] = useField(props);

	return (
		<Wrapper>
			<Label htmlFor={props.id || props.name}>{props.label}</Label>
			<StyledSelect {...field} onChange={props.onChange} disabled = {props.disabled}>
				{!meta.value && <option value=''>{props.placeholder || props.label}</option>}
				{props.options}
			</StyledSelect>
			{
				/**validation error message */
				meta.touched && meta.error ? (
					<ErrorMessage>
						<Span>&#42;</Span>
						{meta.error}
					</ErrorMessage>
				) : null
			}
		</Wrapper>
	);
};

export default Select;

const Wrapper = styled('div')<ComponentProps>`
	display: flex;
	flex-direction: column;
	max-width: ${({ width }) => (width ? width : '100%')};
	width: 100%;
	border-radius: 0.4rem;
	position: relative;
`;

const Label = styled('label')`
	color:#333333;
	padding-bottom: 5px;
  	padding-top: 20px;
	flex: 1 1 100%;
	color: #232323;
	font-style: normal;
	font-weight: normal;
	font-size: 16px;
	letter-spacing: 00.2rem;
	text-transform: capitalize;
`;

const StyledSelect = styled('select')<any>`
	flex: 1 1 100%;
	padding: 1rem 1.5rem;
	font-size: 14px;
	height: 3.6rem;
	box-shadow: 0 0.7rem 0.9rem -3rem rgba(70, 70, 70, 0.06);
	color: var(--color-black-default);
	transition: all 0.5s ease-out;
	transform-origin: top left;
	border: 0.1rem solid #e1e1e1;
	border-radius: 0.4rem;

	&:focus {
		outline: none;
    	border: 0.1rem solid var(--color-primary);
		background: rgb(246, 251, 243);
	}

	&:disabled {
		background-color: #dadada;
	}
`;

const ErrorMessage = styled('menu')`
	color: red;
    font-size: 12px;
    display: flex;
	padding-inline-start: 0px;
`

const Span = styled('span')`
	position: relative;
	top: 5px;
`;
